export enum OrganizationMemberLifecycleStatus {
  ACTIVE = "active",
  PENDING = "pending",
  DEACTIVATED = "deactivated",
  PROVISIONED = "provisioned",
}
